<template>
	<div :class="col + ' component-kira-select'">
		<div class="form-group mb-3">
			<label :for="id">
				<span class="text-truncate">
					{{title}}
				</span>
				<i v-if="required == 'true'" class="fas fa-shield-alt"></i>
			</label>
			<div class="container">
				<input :type="type ? type : 'text'" v-on:input="$emit('input', $event.target.value)"
				class="form-control (maxlength)" :value="value" :required="required" autocomplete="off"
				:id="id ? id : name" :name="name ? name : id" :disabled="Boolean(disabled)" :readonly="Boolean(readonly)" :maxlength="maxlength" :minlength="minlength" :sinEspacios="sinEspacios" @change="removerEspacios($event)">
			</div>
		</div>
	</div> 
</template>
<script>
export default {
	props: [
	'sinEspacios',
	'maxlength',
	'minlength',
	'expanded',
	'required',
	'disabled',
	'readonly',
	'title',
	'value',
	'name',
	'type',
	'id'
	],
	data() { 
		return {
			col: 'col-xs-12 col-md-6 col-lg-4'			
		}
	},
	mounted() {
		const vm = this;
		if(this.expanded && this.expanded == 'true') {
			this.col = 'col-12';
		}
	},	
	methods: {		
		removerEspacios(e) {

			let value = event.target.value;
			let trimedValue = value.replace(/\s/g, '');

			if (this.sinEspacios) {
				
				if ((trimedValue.length < this.minlength) && (trimedValue.length < this.minlength - 1)) {

					toastr["warning"](`El campo ${this.name} tiene como valor requerido mínimo ${this.minlength} carácteres`);

				} else if (trimedValue.length > this.maxlength) {

					toastr["warning"](`El campo ${this.name} tiene como valor requerido excede ${this.maxlength} carácteres`);
				}

				event.target.value = trimedValue.toUpperCase();

			}
		}
	}
}
</script>
